export default function KenyaTeaser() {
    return (
        <div className="max-w-2xl mt-10 mb-20 mx-auto p-6">
            <div className="bg-white dark:bg-gray-900 shadow-lg overflow-hidden">
                <div className=" p-6  text-white text-center">
                    <div className="flex justify-center mb-4">
                        <svg className="w-8 h-8 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12.4472 2.10557c-.2815-.14076-.6129-.14076-.8944 0L5.90482 4.92956l.37762.11119c.01131.00333.02257.00687.03376.0106L12 6.94594l5.6808-1.89361.3927-.13363-5.6263-2.81313ZM5 10V6.74803l.70053.20628L7 7.38747V10c0 .5523-.44772 1-1 1s-1-.4477-1-1Zm3-1c0-.42413.06601-.83285.18832-1.21643l3.49538 1.16514c.2053.06842.4272.06842.6325 0l3.4955-1.16514C15.934 8.16715 16 8.57587 16 9c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z" />
                            <path d="M14.2996 13.2767c.2332-.2289.5636-.3294.8847-.2692C17.379 13.4191 19 15.4884 19 17.6488v2.1525c0 1.2289-1.0315 2.1428-2.2 2.1428H7.2c-1.16849 0-2.2-.9139-2.2-2.1428v-2.1525c0-2.1409 1.59079-4.1893 3.75163-4.6288.32214-.0655.65589.0315.89274.2595l2.34883 2.2606 2.3064-2.2634Z" />
                        </svg>
                    </div>
                    <h1 className="text-2xl font-bold dark:text-gray-300 text-gray-900">Études au Kenya</h1>
                </div> 
                <div className="p-6 space-y-6">
                    <p className="text-gray-700 dark:text-gray-300 mb-10 leading-relaxed text-lg text-center">
                        Le système éducatif kenyan regorge de richesses et d'opportunités. En choisissant d'étudier au Kenya, vous
                        entrez dans un environnement académique dynamique, principalement anglophone, qui figure parmi les meilleurs
                        du continent africain...
                    </p>              
                    <div className="text-center">
                        <a
                            href="/mksp/kenya-education-info"
                            className="inline-flex items-center bg-green-800 dark:bg-green-700 gap-2 hover:bg-green-700 dark:hover:bg-green-900 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
                        >
                            voir plus 
                            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
